import { actionTypes } from '../actions';

const initialState = {
  issues: {}
}

const magazine = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_MAGAZINE_ISSUES:
      return { 
        ...state,
        issues: action.issues,
        issuesLastFetched: Date.now()
      };

    case actionTypes.SET_MAGAZINE_CURRENT_ISSUE:
      return {
        ...state,
        currentIssue: action.currentIssue,
        currentIssueLastFetched: Date.now()
      };

    default:
      return state;
  }
};

export default magazine;



// WEBPACK FOOTER //
// ./src/reducers/magazine.js